import "firebase/auth";

export default {
  apiKey: "AIzaSyA0xtj2cxhDWFa7-e_Q5T174jJ9UAdH_8U",
  authDomain: "my-app-f5ed0.firebaseapp.com",
  projectId: "my-app-f5ed0",
  storageBucket: "my-app-f5ed0.appspot.com",
  messagingSenderId: "1034974960720",
  appId: "1:1034974960720:web:525635eb5be3421fdc0555"
  };



  
// import Firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/firestore";
// var firebaseConfig = {
//     apiKey: "AIzaSyA0xtj2cxhDWFa7-e_Q5T174jJ9UAdH_8U",
//     authDomain: "my-app-f5ed0.firebaseapp.com",
//     projectId: "my-app-f5ed0",
//     storageBucket: "my-app-f5ed0.appspot.com",
//     messagingSenderId: "1034974960720",
//     appId: "1:1034974960720:web:525635eb5be3421fdc0555"
//   };
//    const firebase = Firebase.initializeApp(firebaseConfig);
//   const db = firebase.firestore();
//   export  {firebase,db};